import HttpRequest from './HttpRequest';

export const getPublisher = async () => {
  try {
    const response = await HttpRequest.get('/publishers');
    return response;
  } catch (err) {
    console.error(err);
    return null;
  }
};
